import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthenticationResult } from './models/authentication.model';

@Injectable({
  providedIn: 'root'
})
export class AuthUserService {

  constructor(private httpClient: HttpClient) { }
  private _url = environment.apiUrl;
 
  sendAuthData(actionName:string,data: any): Observable<any> { //should get specific types representing the possible entities

    return this.httpClient.post<AuthenticationResult>(this._url.concat(actionName), data, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    })
  }
}
